import {
  Box,
  Stack,
  styled
} from '@mui/material';
import {
  ChatPane,
  StockTickerList
} from 'modules';
import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';



const ScrollableBox = styled(Box)(({ theme }) => ({
  height: `calc(100vh - 114px)`,
  overflowY: 'scroll'
}));



export type SherlockChatActivityProps = {};

export const SherlockChatActivity = (props: SherlockChatActivityProps) => {
  const params = useParams();
  const location = useLocation();
  const companyId = params.companyId ?? '';
  const navigate = useNavigate();

  const handleNavigate = (id: string) => {
    if ((companyId === '') && location.pathname.includes('insights')) {
      navigate(`/insights/${id}`);
    } else {
      navigate(`../${id}`);
    }
  };

  return (
    <Stack direction='row' gap={1}>
      <ScrollableBox
        maxWidth='13rem'
      >
        <StockTickerList.FC
          selectedCompanyId={companyId}
          onClick={(id: string) => {
            handleNavigate(id);
          }}
        />
      </ScrollableBox>

      <ScrollableBox
        sx={{
          flex: 1
        }}
      >
        <ChatPane.FC
          defaultOpen
          listedCompanyId={companyId}
        />
      </ScrollableBox>
    </Stack>
  );
};
